module.exports = __webpack_public_path__ + "static/img/Seat-Branding.3fd5b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Seat-Branding.jpg
// module id = GrJq
// module chunks = 11